<template>
  <div class="home-page">    
    <!-- 活動標題與介紹區塊 -->
    <div class="div-centerY ActiveAllInfo">
      <div v-if="isPC" class="ActiveTitle">{{ eventData.name }}</div>
      <div v-else class="ActiveTitle PC div-center" v-html="eventData.name"></div>
      <div class="ActiveInfoDiv oneLine">
        <div class="ActivePic">
          <img class="pic" :src="eventData.bannerImage || defaultBanner" alt="">
        </div>
        <div class="titleContentArea">
          <div class="otherInfoArea">
            <div v-html="eventData.description"></div>
            <div class="Replenish" v-if="eventData.disclaimer">{{ eventData.disclaimer }}</div>
          </div>  
        </div>
      </div> 
    </div>

    <!-- 按鈕區塊 -->
    <div class="oneLine div-center">
      <div :class="['joinButtonArea', !isPC && 'div-center']" v-if="eventData.introUrl">
        <div :class="['joinButton', 'downLoad', 'load', 'whiteColor', 'div-center', isPC && 'PC']">
          <a :href="eventData.introUrl" target="_blank">
            <div class="txt" style="color:white;">
              活動簡介與說明
              <el-icon><ArrowRightBold /></el-icon>
            </div> 
          </a>
        </div>
      </div>            
      <div class="joinButtonArea" v-if="!isSignUpClosed" @click="BtnFunction('join')">        
        <div :class="['joinButton', 'whiteColor', 'div-center', ((ActiveStart && PageStatus===0) ? 'onClick' : ''), 'mar-right', isPC && 'PC']">
          <div class="txt" translate="no">
            {{ isPreSignUp ? "我要預報名" : "我要報名" }}
            <el-icon><ArrowRightBold /></el-icon>
          </div> 
        </div>
      </div>
      <div :class="['joinButtonArea', !isPC && 'div-center']" v-if="isReviewer && eventData.features?.allowReviewer">
        <div :class="['joinButton', 'downLoad', 'load', 'whiteColor', 'div-center', isPC && 'PC']">
          <a href='javascript:void(0)' @click="gotoTeammodel('%2Fhome%2FhtExamMark')">
            <div class="txt" style="color:white;">
              評審閱卷
              <el-icon><ArrowRightBold /></el-icon>
            </div> 
          </a>
        </div>
      </div>
    </div>
    
    <!-- 已報名班級區塊 -->
    <div class="div-center">             
      <div class="cotentDiv oneLine">        
        <div :class="isPC ? 'tableDiv class left' : 'tableDiv left'" v-if="isJoin && (classListCtrl || PageStatus !== 0)">
          <div class="dialog-header">                          
            <span class="title_school" style="margin-left: auto;margin-right: auto;">{{ enrolledSchoolInfo.schoolName }}</span>         
          </div>  
          <div class="between titleDiv">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/bean/bean_01.png" alt=""> 
              已報名班級：
            </div>
            <span class="spanTotal2" v-show="isPC">合計{{ selectedCoursesCount }}班， 預估{{ totalExpStuNum }}人，已有{{ totalStudents }}人</span>
            <span style="width: 30%;"></span>           
            <div class="picButton" @click="BtnFunction('edit')" v-if="PageStatus === 1 || (PageStatus === 2 && applyInfoData.length > 0)" v-show="isPC">
              <img class="buttonImg" src="../../assets/img/area-01.png" alt="">
              <div class="pngText div-centerY">
                新增/管理報名班級
              </div>
            </div>
          </div>

          <div v-if="!isPC">
            <!-- 手機版已報名班級列表 -->
            <div class="PhoneArea" v-for="(data, i) in applyInfoData" :key="i">
              <div class="left">
                <span class="title">{{ data.group }}</span>
              </div>
              <div class="between">
                <div class="left">
                  <span style="margin-right:20px">{{ data.course }}</span>
                  <span>{{ data.class }}</span>
                </div>
                <div class="left">
                  <span style="margin-right:20px">人數：{{ data.students }}</span>                  
                </div>
              </div>
              <div v-if="PageStatus === 2" class="left">
                <div class="stressColor">{{ data.stage }}</div>
              </div>
              <div class="line" v-if="i !== (applyInfoData.length - 1)"></div>
            </div>
          </div>
          <div v-else class="tableArea">
            <!-- 電腦版已報名班級表格 -->
            <el-table :data="applyInfoData" style="width: 100%">              
              <el-table-column prop="group" label="組別" />
              <el-table-column prop="course" label="班級">
                <template #default="scope">
                  <div>{{ scope.row.course }} - {{ scope.row.class }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="students" label="人數" />              
              <el-table-column prop="stage" label="進行階段" v-if="PageStatus === 2">
                <template #default="scope">
                  <div class="stressColor">{{ scope.row.stage }}</div>
                </template>
              </el-table-column>
              <el-table-column v-if="PageStatus === 2" label="" width="100">
                <template #default="">
                  <div @click="gotoTeammodel('%2Fhome%2FprivExam')" class="otheBlueColor" style="cursor: pointer;">                  
                    詳細數據
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>   
        </div>   
      </div>
    </div>
    
    <!-- 得獎名單區塊 - 活動結束後才顯示 -->
    <div class="div-center" v-if="isAwardRevealed && eventData.awards?.length > 0">
      <div class="cotentDiv oneLine">
        <div class="tableDiv right">
          <div class="titleDiv winArea oneLine">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/awards_medal.png" alt=""> 
              得獎名單：
            </div>
          </div>
          
          <!-- 電腦版得獎名單 -->
          <div v-if="isPC">
            <div v-if="eventData.awardNotice" style="text-align: left;">
              <div v-html="eventData.awardNotice"></div>
            </div>
            <div :class="i === 0 ? 'winCotent div-centerY' : 'winCotent div-centerY'" v-for="(group, i) in eventData.awards" :key="i">
              <div class="ContestTitle isPc oneLine">{{ group.title }}</div>
              <div class="tableCss">                
                <el-table :data="group.data">
                  <el-table-column prop="rank" label="排名" width="180">
                    <template #default="scope">
                      <div class="oneLine">
                        <img v-if="scope.row.rank === '1'" class="iconPic" src="../../assets/img/awards/awards_trophy1.png" alt=""> 
                        <img v-else-if="scope.row.rank === '2'" class="iconPic" src="../../assets/img/awards/awards_trophy2.png" alt=""> 
                        <img v-else-if="scope.row.rank === '3'" class="iconPic" src="../../assets/img/awards/awards_trophy3.png" alt=""> 
                        <img v-else-if="scope.row.rank === 'excellent'" class="iconPic" src="../../assets/img/awards/awards_decoration1.png" alt=""> 
                        <img v-else-if="scope.row.rank === 'Shortlisted'" class="iconPic" src="../../assets/img/awards/awards_decoration2.png" alt=""> 
                        <span class="otheBlueColor winTxt" v-if="scope.row.rank === '1'">第一名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === '2'">第二名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === '3'">第三名</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === 'excellent'">優秀獎</span>
                        <span class="otheBlueColor winTxt" v-else-if="scope.row.rank === 'Shortlisted'">入圍獎</span>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="school" label="學校" />
                  <el-table-column prop="class" label="班級名稱" width="200" />
                  <el-table-column prop="TName" label="帶隊教師" width="100">
                    <template #default="scope">
                      <div class="otheBlueColor">{{ scope.row.TName }}</div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          
          <!-- 手機版得獎名單 -->
          <div v-else>
            <div v-if="eventData.awardNotice" style="text-align: left;">
              <div v-html="eventData.awardNotice"></div>
            </div>
            <div :class="i === 0 ? 'winCotent div-centerY' : 'winCotent div-centerY'" v-for="(group, i) in eventData.awards" :key="i">
              <div class="ContestTitle oneLine">{{ group.title }}</div>
              <div v-for="(item, k) in group.data" :key="k" class="tableCssPhone">
                <div class="Div1 between">
                  <div class="oneLine div-centerY2">
                    <img v-if="item.rank === '1'" class="iconPic" src="../../assets/img/awards/awards_trophy1.png" alt=""> 
                    <img v-else-if="item.rank === '2'" class="iconPic" src="../../assets/img/awards/awards_trophy2.png" alt=""> 
                    <img v-else-if="item.rank === '3'" class="iconPic" src="../../assets/img/awards/awards_trophy3.png" alt=""> 
                    <img v-else-if="item.rank === 'excellent'" class="iconPic" src="../../assets/img/awards/awards_decoration1.png" alt=""> 
                    <img v-else-if="item.rank === 'Shortlisted'" class="iconPic" src="../../assets/img/awards/awards_decoration2.png" alt=""> 
                    <span class="otheBlueColor winTxt" v-if="item.rank === '1'">第一名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === '2'">第二名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === '3'">第三名</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === 'excellent'">優秀獎</span>
                    <span class="otheBlueColor winTxt" v-else-if="item.rank === 'Shortlisted'">入圍獎</span>
                  </div>
                  <div class="Div2">
                    <div class="left">{{ item.school }}</div> 
                    <div class="left">
                      <span class="gray1Color rightSet">{{ item.class }}</span>
                      <span class="otheBlueColor">{{ item.TName }}</span>
                    </div>
                  </div>
                </div>
                <p class="line"></p>
              </div>
            </div>
          </div>
        </div>

        <!-- 優選學校區塊 - 活動結束後才顯示 -->
        <div class="tableDiv right" v-if="eventData.excellentSchools?.length > 0">
          <div class="titleDiv between">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/awards_trophies.png" alt=""> 
              {{ eventData.excellentSchoolsTitle || '優選學校' }}：
            </div>
          </div>
          <div class="schoolList" :style="isPC ? 'margin-left: 30px' : ''">
            <div class="list" v-for="(school, index) in eventData.excellentSchools" :key="index">
              <img class="iconPic" :src="getStarIcon(index)" alt=""> 
              {{ school }}
              <img class="iconPic" :src="getStarIcon(index)" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 表單填寫提醒 - 活動結束後才顯示 -->
    <div v-if="isAwardRevealed && eventData.formUrl" class="div-center" style="width: 100%; margin-top: 50px;">
      <div v-if="isPC" class="award-form-notice-pc">
        <div style="font-size: 25px; font-weight: 700; margin-bottom: 20px">
          {{ eventData.formTitle || '請得獎教師務必填寫此表' }} <br/><br/>                
          <span class="form-link-decoration">📝</span>
          <a :href="eventData.formUrl" style="color: #2d8cf0;" target="_blank">表單連結</a>                               
          <br/><br/>
          <span v-if="eventData.formDeadline">*請於 {{ eventData.formDeadline }} 前回填完此表單，以利活動後續作業</span>
        </div>                  
      </div>
      <div v-else class="award-form-notice-mobile" style="width: 80%; height: 300px; margin-left: 10%; margin-right: 10%;">
        <div class="mobile-notice-text">
          {{ eventData.formTitle || '請得獎教師務必填寫此表' }} <br/><br/>
          <span class="form-link-decoration">📝</span>
          <a :href="eventData.formUrl" style="color: #2d8cf0;" target="_blank">表單連結</a>                        
          <br/><br/>
          <div class="deadline-notice" v-if="eventData.formDeadline">
            *請於 {{ eventData.formDeadline }} 前回填完此表單
          </div>
        </div>                  
      </div>      
    </div>
                    
    <!-- 重要時程區塊 -->
    <div class="div-center" style="margin-bottom: 20px;">
      <div class="cotentDiv oneLine">                
        <div class="tableDiv right">
          <div class="titleDiv between">
            <div class="title oneLine div-centerY YUnset">
              <img class="iconPic" src="../../assets/img/other_book.png" alt=""> 
              重要時程：
            </div>
          </div>
          
          <!-- 手機版時程 -->
          <div v-if="!isPC">
            <div v-for="(data, i) in PlanData" :key="i" class="scheduleArea">
              <div class="between titleArea">
                <div class="oneLine titleSet">
                  <div><span class="otheBlueColor stepName">{{ data.stepName }}</span></div>
                  <div class="current_progress" v-if="data.isNow">※目前活動進度</div>
                </div>
                <div style="font-size: 20px;" v-if="isJoin && PageStatus !== 0">
                  <a :href="data.url" target="_blank" v-if="data.urlOpen && data.url !== ''">
                    <el-icon><Download /></el-icon>
                  </a>
                </div>
              </div>
              <div class="card">
                <div class="between place">                
                  <div>地點：<span v-html="data.location"></span></div>
                </div>                
                <div class="between time" style="color:#999">
                  <div>{{ data.startTime }} ~ {{ data.endTime }}</div>                
                </div>
                <div class="description" v-html="data.description"></div>
              </div>
              <div class="triangleArea div-center" v-if="i !== (PlanData.length - 1)">
                <div>
                  <div class="triangle"></div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- 電腦版時程表格 -->
          <div class="tableArea" v-else>
            <el-table :data="PlanData" style="width: 100%" :row-class-name="PlanDataRowClass">
              <el-table-column prop="startTime" label="時程">
                <template #default="scope">
                  <div>{{ scope.row.startTime }} ~ {{ scope.row.endTime }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="stepName" label="階段" :width="isNarrow ? 'auto' : 150">
                <template #default="scope">
                  <div class="otheBlueColor">{{ scope.row.stepName }}</div>
                  <span v-if="scope.row.isNow" class="current_progress">目前活動進度</span>
                </template>
              </el-table-column>
              <el-table-column prop="location" label="地點" :width="isNarrow ? 'auto' : 200">
                <template #default="scope">
                  <div class="info-cell" v-html="scope.row.location"></div>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="說明">
                <template #default="scope">
                  <div class="info-cell" v-html="scope.row.description"></div>
                </template>
              </el-table-column>
              <el-table-column v-if="isJoin && PageStatus !== 0" prop="url" label="下載" width="70">
                <template #default="scope">
                  <div class="URL" style="font-size: 20px;">
                    <a :href="scope.row.url" target="_blank" v-if="scope.row.urlOpen && scope.row.url !== ''">
                      <el-icon><Download /></el-icon>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>                       
      </div>
    </div>

    <!-- 頁尾單位資訊 -->
    <div :class="isPC ? 'footerDiv div-center' : 'footerDiv phone div-center'" v-if="eventData.sponsors">
      <div class="txtDiv">
        <template v-if="eventData.sponsors.supervisor?.length">
          指導單位：{{ eventData.sponsors.supervisor.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.organizer?.length">
          主辦單位：{{ eventData.sponsors.organizer.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.coOrganizer?.length">
          協辦單位：{{ eventData.sponsors.coOrganizer.join('、') }}<br/>
        </template>
        <template v-if="eventData.sponsors.partner?.length">
          合作單位：{{ eventData.sponsors.partner.join('、') }}<br/>
        </template>
      </div>
    </div>

    <!-- ========== 對話框區塊 ========== -->
    
    <!-- 報名視窗 -->     
    <el-dialog v-model="dialogSignUpCtrl" class="applyTableDiv div-centerY signup-dialog" width="40%" top="6vh" style="height: 675px">
      <template #header>
        <div class="dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title">報名活動</span>
        </div>
      </template>    
      <div class="signup-form-wrap">
        <!-- 步驟 1：確認報名資訊 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">1</span> 確認報名資訊</div>
          <div class="signup-info-group">
            <div class="signup-field-row">
              <span class="signup-field-label">報名學校</span>
              <span class="signup-field-value">{{ userSchool.schoolName }}</span>
            </div>
            <div class="signup-field-row">
              <span class="signup-field-label">雲端個人課程名單</span>
              <span class="signup-field-value">{{ selectedRow?.name }}</span>
            </div>
          </div>
        </div>

        <!-- 步驟 2：填寫報名資料 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">2</span> 填寫報名資料</div>
          <div class="form-item">
            <strong>報名組別：</strong>
            <el-cascader v-model="selectedRow.groupId" :options="groupListOption" style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
          </div>
          <div class="form-item" style="margin-bottom:0">
            <strong>Email 填寫/確認：</strong>
            <el-input v-model="signUpEmail" style="width:100%; --el-input-border-color:#999; --el-input-focus-border-color:#999;" />
            <div style="font-size:13px; margin-top:8px; color:#666; line-height:1.7;">
              <div>📌 接收本次活動報名及活動階段通知</div>
              <label style="display:flex; align-items:center; gap:6px; cursor:pointer;">
                <input type="checkbox" v-model="isSaveMainEmail" :disabled="isMustSaveMainEmail" />
                將此 Email 作為帳號的主要聯絡信箱
              </label>
            </div>
          </div>
        </div>

        <!-- Action Bar -->
        <div class="signup-dialog-footer">
          <el-button @click="dialogAddClassConfirm()" round type="primary" size="large">送出報名</el-button>
          <el-button @click="dialogSignUpCtrl = false" round type="danger" size="large">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 登入後提示訊息 -->
    <el-dialog v-model="dialogAfterLoginCtrl" width="25%" top="15vh" class="login-dialog">
      <template #header>
        <div class="login-dialog-header">
          <span class="login-dialog-title">{{ eventData.name }}</span>
        </div>
      </template>    
      <div class="login-dialog-content">
        <p>您已登入成功！</p>
        <br>    
        <div v-if="!isSignUpClosed">如欲報名活動，請點選 <strong>「<a class="a_color" @click="BtnFunction('join')">{{ isPreSignUp ? "我要預報名" : "我要報名" }}</a>」</strong> 進行報名。</div>    
        <div v-else>報名時間已結束。</div>
      </div>
    </el-dialog>

    <!-- 手機版登入提示 -->
    <el-dialog v-model="dialogAfterLoginNoPCCtrl" width="90%" top="15vh" class="login-dialog">
      <template #header>
        <div class="login-dialog-header">
          <span class="login-dialog-title">{{ eventData.name }}</span>
        </div>
      </template>    
      <div class="login-dialog-content">              
        <div>如欲報名活動，請用網頁進行報名。</div>    
      </div>
    </el-dialog>

    <!-- 設定學校對話框 -->
    <el-dialog v-model="dialogSetSchoolCtrl" width="25%" top="10vh" class="custom-dialog">
      <template #header>
        <div class="dialog-header">            
          <span class="dialog-title">請設定所屬學校</span>
        </div>
      </template>
      <div class="dialog-content">
        <el-cascader v-model="selectedLocation" :options="cascaderOptions" :props="cascaderProps" size="large" class="custom-input"
          placeholder="請選擇地區" style="width: 300px" clearable @change="handleLocationChange" />
        <br/>
        <el-select v-model="selectedSchool" placeholder="請選擇學校" size="large" style="width: 240px" filterable class="custom-input">
          <el-option v-for="item in optionsSchool" :key="item.code" :label="item.name" :value="item.code" />
        </el-select>
        <br/>
        <el-button type="primary" round class="submit-button" @click="setSchoolsubmit()">送出</el-button>
      </div>    
    </el-dialog>

    <!-- 班級管理對話框 -->
    <el-dialog v-model="dialogAddClassCtrl" class="applyTableDiv div-centerY" width="60%" top="5vh">
      <template #header>
        <div class="dialog-header">
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title">參賽班級管理</span>                          
        </div>
      </template>
      <div class="content div-center2">
        <div class="info" v-html="eventData.signUpGuide || defaultSignUpGuide"></div>
        <div class="school-header" style="text-align: center;">                          
          <span class="title" >
            {{ userSchool.schoolName }}
          </span>         
        </div>        
        <div class="chooseArea2" style="display: flex; justify-content: center; flex-direction: column; align-items: center; gap: 15px;">
          <div style="display: flex; justify-content: flex-start; gap: 30px; flex-wrap: wrap; width: 100%; align-items: center;">
            <el-button type="primary" v-if="!isSignUpClosed" @click="openCreateClass('crt')">新建簡易名單</el-button>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">已報名班級總數：{{ selectedCoursesCount }}</span>
            <span style="color:#E88847; font-size: 15px; font-weight: 600;">人數：{{ totalStudents }}</span>
          </div>
        </div>
        <!-- 純 HTML 卡片列表（取代 el-table） -->
        <div class="cardListContainer">
          <!-- 表頭 -->
          <div class="cardListHeader">
            <div class="cardColumn col-name">雲端個人課程名單</div>
            <div class="cardColumn col-students">人數</div>
            <div class="cardColumn col-edit">編輯</div>
            <div class="cardColumn col-group">組別</div>
            <div class="cardColumn col-action">操作</div>
          </div>
          
          <!-- 卡片列表 -->
          <div class="cardListBody">
            <div v-for="(row, index) in applyTableData" :key="index" class="cardRow">
              <!-- 課程名稱列 -->
              <div class="cardColumn col-name">
                <span>{{ row.courseName }} - {{ row.name }}</span>
                <span class="highlight-row" v-show="row.groupId.some((id) => id.toString().trim() !== '')">已報名</span>
              </div>
              
              <!-- 人數列 -->
              <div class="cardColumn col-students">
                <span>{{ row.students }}人</span>
              </div>
              
              <!-- 編輯簡易名單列 -->
              <div class="cardColumn col-edit">
                <button 
                  v-if="row.type === 'simple' && !isAfterWarmUpStage" 
                  class="btn btn-warning"
                  @click="openCreateClass('upd', row)">
                  編輯簡易名單
                </button>
              </div>
              
              <!-- 組別列 -->
              <div class="cardColumn col-group">
                <span>{{ getGroupName(row.groupId[0]) }}</span>
              </div>
              
              <!-- 操作列 -->
              <div class="cardColumn col-action">
                <button 
                  v-show="row.groupId[0] !== ''" 
                  class="btn btn-secondary"
                  @click="openSelectItem(row)">
                  編輯
                </button>
                <button 
                  v-if="row.groupId[0] !== ''" 
                  class="btn btn-danger"
                  @click="cancelConfirm(row)">
                  取消
                </button>
                <button 
                  v-else-if="!isSignUpClosed" 
                  class="btn btn-primary"
                  @click="openSelectItem(row)">
                  報名
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>      
    </el-dialog>

    <!-- 新增/變更班級對話框 -->
    <el-dialog v-model="dialogCreateClassCtrl" class="applyTableDiv div-centerY" style="width: 40%;" top="2vh">
      <template #header>
        <div class="dialog-header">          
          <img class="iconPic" src="../../assets/img/bean/bean_02.png" alt="">
          <span class="title">新增/變更參賽班級名單</span>                          
        </div>
      </template>
      <div class="content div-center2">
        <!-- 步驟 1：填寫班級名稱 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">1</span> 填寫班級名稱</div>
          <div class="school-header">
            <div class="createClass-name-row">
              <span class="createClass-course-tag">{{ courseName }}</span>
              <span class="createClass-dash">—</span>
              <el-input v-model="grouplistName" placeholder="請輸入班級名稱，例如：一年一班" style="flex:1; max-width:280px; --el-input-border-color:#999999; --el-input-focus-border-color:#999999; --el-input-bg-color:#fff; font-size:15px;" />
            </div>
          </div>
        </div>

        <!-- 步驟 2：輸入學生名單 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">2</span> 輸入學生名單</div>
          <div class="info">
            <div class="createClass-hint-body">
              <div class="createClass-hint-text">
                <div>📋 格式：<strong>名字,座號</strong>，每行一位；💡 可直接從 Excel 複製兩欄資料貼上</div>
              </div>
              <div class="createClass-hint-img">
                <img src="./../../assets/img/2024091301.jpg" class="hint-img-zoom" style="max-width:90px; border-radius:6px; border:1px solid #a9cce3;" />
              </div>
            </div>
          </div>
          <div class="createClass-editor">
            <div class="createClass-editor-col">
              <div class="createClass-col-label">貼上名單</div>
              <el-input
                type="textarea"
                v-model="studentInput"
                placeholder="大雄,1
胖虎,2
小夫,3"
                rows="7"
                style="width:100%; --el-input-border-color:#999999; --el-input-focus-border-color:#999999;"
              />
            </div>
            <div class="createClass-editor-arrow">
              <button class="btn btn-primary createClass-add-btn" @click="addStudents">加入 →</button>
            </div>
            <div class="createClass-editor-col">
              <div class="createClass-col-label">確認名單（{{ students.length }} 人）</div>
              <el-table :data="students" border style="width:100%; --el-table-border-color:#999999; --el-border-color:#999999;" max-height="200" empty-text="尚無學生">
                <el-table-column prop="name" label="名字" />
                <el-table-column prop="seat" label="座號" width="70" />
                <el-table-column label="" width="60" >
                  <template #default="scope">
                    <div style="display:flex; justify-content:center;">
                      <el-button type="danger" size="small" @click="deleteStudent(scope.$index)">刪除</el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 步驟 3：確認送出 -->
        <div class="createClass-step">
          <div class="createClass-step-label"><span class="step-badge">3</span> 確認送出</div>
          <div class="chooseArea2" style="text-align:center; padding: 16px;">
            <el-button type="primary" size="large" @click="submitCourse">確定新增/變更</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- Loading 狀態 -->
    <div v-if="isLoading" class="loading-overlay">
      <el-icon class="is-loading" :size="50"><Loading /></el-icon>
      <p>載入活動資料中...</p>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, reactive, onMounted, onUnmounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';
import { Loading } from '@element-plus/icons-vue';
import country_v2 from '@/static/regions/country_v2.json';
import api from '@/api';

// ==================== 路由與活動 ID ====================
const route = useRoute();
const ActivityID = ref('');

// 寫死的活動 ID（開發/展示用）：設為 '' 則從 URL query 取得並呼叫 API
const HARDCODED_EVENT_ID = '';

// ==================== Mock 資料 ====================
const mockEventData = {
  // 測試活動 1 - 閱讀好小子
  'test-event-001': {
    id: 'test-event-001',
    name: '2025 全國閱讀好小子學藝競賽',
    description: `
      <p>本活動參考了
        <a class="a_color" href="https://cirn.moe.edu.tw/WebContent/index.aspx?sid=1199&mid=14127" target="_blank">PISA</a>、
        <a class="a_color" href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1201" target="_blank">PIRLS</a>
        等級的素養文本，並結合專家設計命題，呈現多元且有趣的閱讀素養題型，激發學生的學習興趣。
      </p>
      <p>透過HiTeach教學軟體，可以在課堂上更快速、高效地進行閱讀測驗，讓師生親身體驗科技融入教學的優勢，同時提升生生用平板的應用成效。</p>
      <p>歡迎各班級踴躍參與，共同探索學習新體驗！</p>
    `,
    disclaimer: '*本活動數據將不會作為研究用途',
    bannerImage: '',
    introUrl: '/goodkid',
    loginType: ['tmdId', 'eduId'],
    schedule: [
      { id: 'step1', name: '報名', startTime: 1725206400000, endTime: 1727711999000, location: '線上', description: '開放教師報名參加' },
      { id: 'step2', name: '班級熱身賽', startTime: 1727712000000, endTime: 1728921599000, location: '各校教室', description: '班級進行熱身練習' },
      { id: 'step3', name: '初賽', startTime: 1728921600000, endTime: 1730131199000, location: '各校教室', description: '進行初賽評比' },
      { id: 'step4', name: '決賽', startTime: 1730131200000, endTime: 1769751907910, location: '線上', description: '決賽評比與頒獎' },
    ],
    groups: [
      { id: 'group-low', name: '國小低年級組' },
      { id: 'group-mid', name: '國小中年級組' },
      { id: 'group-high', name: '國小高年級組' },
      { id: 'group-junior', name: '國中組' },
    ],
    features: {
      showAwards: true,
      showExcellentSchools: true,
      showFormReminder: true,
      allowReviewer: true
    },
    awards: [
      {
        title: '低年級組',
        data: [
          { rank: '1', school: '高雄市前金國小', TName: '吳婕鳳', class: '一年二班' },
          { rank: '2', school: '高雄市前金國小', TName: '廖敏娟', class: '二年四班' },
          { rank: '3', school: '高雄市前金國小', TName: '許文華', class: '一年三班' },
          { rank: 'excellent', school: '高雄市前金國小', TName: '陳美靜', class: '一年一班' },
          { rank: 'excellent', school: '南投縣爽文國小', TName: '郭月琴', class: '二年甲班' },
        ]
      },
      {
        title: '中年級組',
        data: [
          { rank: '1', school: '桃園市大華國小', TName: '何世甯', class: '四年一班' },
          { rank: '2', school: '高雄市前金國小', TName: '王珮楹', class: '三年十一班' },
          { rank: '3', school: '高雄市前金國小', TName: '黃姿蓉', class: '四年四班' },
        ]
      },
      {
        title: '高年級組',
        data: [
          { rank: '1', school: '臺中市樹義國小', TName: '段菀翠', class: '五年一班' },
          { rank: '2', school: '雲林縣鎮南國小', TName: '劉文尚', class: '六年一班' },
          { rank: '3', school: '澎湖縣文光國小', TName: '郭訓豪', class: '六年一班' },
        ]
      },
      {
        title: '國中組',
        data: [
          { rank: '1', school: '南投縣三光國中', TName: '蕭秀緞', class: '九年一班' },
          { rank: '2', school: '新北市忠孝國中', TName: '林佳樺', class: '九年五班' },
          { rank: '3', school: '臺北市中崙高中', TName: '陳蕙瑤', class: '八年三班' },
        ]
      }
    ],
    awardNotice: '恭喜以下獲獎班級！頒獎典禮將於近期舉行。',
    excellentSchoolsTitle: '全國閱讀好小子優選學校',
    excellentSchools: [
      '高雄市立前金國小',
      '臺北市立信義國中',
      '新北市立忠孝國中',
      '南投縣立北投國小',
      '臺北市立志清國小'
    ],
    formUrl: 'https://forms.gle/example',
    formTitle: '請得獎教師務必填寫此表',
    formDeadline: '09/17(三)',
    sponsors: {
      supervisor: ['教育部國民及學前教育署'],
      organizer: ['臺灣科技領導與教學科技發展協會', '臺灣讀寫教學研究學會', '小貓頭鷹智慧聯盟校'],
      coOrganizer: ['新竹縣政府教育局', '臺中市政府教育局', '南投縣政府教育處'],
      partner: ['大穎文化事業股份有限公司', '小魯文化事業股份有限公司']
    },
    signUpGuide: `
      一、HiTeach軟體安裝與基本操作 <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=274" target="_blank">GO</a>! <br>
      二、建立名單與官網班級報名畫面 <a class="urlCss" href="https://www.habook.com/zh-tw/faq.php?act=view&id=263#join" target="_blank">GO</a>! <br>
      三、注意事項：如老師遇到不確定「新學期所教班級」之狀況，本次活動在報名時，透過簡易名單，可先填寫預計參加的班級、預估人數，做預報名。
    `
  },
  
  // 測試活動 2 - 數學競賽
  'test-event-002': {
    id: 'test-event-002',
    name: '2025 全國數學素養挑戰賽',
    description: `
      <p>本活動結合數學素養與邏輯思考，透過有趣的題目設計，培養學生解決問題的能力。</p>
      <p>採用 HiTeach 互動教學系統進行即時評量，讓學習更有效率！</p>
    `,
    disclaimer: '*活動成績僅供參考',
    bannerImage: '',
    introUrl: '/math-challenge',
    loginType: ['tmdId'],
    schedule: [
      { id: 'step1', name: '預報名', startTime: 1725206400000, endTime: 1726415999000, location: '線上', description: '開放預先報名' },
      { id: 'step2', name: '正式報名', startTime: 1726416000000, endTime: 1727711999000, location: '線上', description: '正式報名階段' },
      { id: 'step3', name: '線上競賽', startTime: 1727712000000, endTime: 1728921599000, location: '各校電腦教室', description: '進行線上數學競賽' },
      { id: 'step4', name: '成績公布', startTime: 1728921600000, endTime: 1729525199000, location: '線上', description: '公布成績與頒獎' },
    ],
    groups: [
      { id: 'group-elementary', name: '國小組' },
      { id: 'group-junior', name: '國中組' },
      { id: 'group-senior', name: '高中組' },
    ],
    features: {
      showAwards: true,
      showExcellentSchools: false,
      showFormReminder: true,
      allowReviewer: false
    },
    awards: [
      {
        title: '國小組',
        data: [
          { rank: '1', school: '臺北市大安國小', TName: '王老師', class: '六年一班' },
          { rank: '2', school: '新北市板橋國小', TName: '李老師', class: '五年三班' },
          { rank: '3', school: '桃園市中正國小', TName: '張老師', class: '六年二班' },
        ]
      },
      {
        title: '國中組',
        data: [
          { rank: '1', school: '臺北市建國中學', TName: '陳老師', class: '八年五班' },
          { rank: '2', school: '新北市江翠國中', TName: '林老師', class: '九年一班' },
        ]
      }
    ],
    awardNotice: '',
    excellentSchoolsTitle: '',
    excellentSchools: [],
    formUrl: 'https://forms.gle/math-example',
    formTitle: '請得獎教師填寫領獎資料',
    formDeadline: '10/15(二)',
    sponsors: {
      supervisor: ['教育部'],
      organizer: ['臺灣數學教育學會'],
      coOrganizer: ['各縣市教育局'],
      partner: []
    },
    signUpGuide: `
      一、請先確認已安裝 HiTeach 最新版本<br>
      二、建立班級名單後即可報名參加
    `
  },
  
  // 測試活動 3 - 進行中的活動（可用於測試報名版面）
  'test-event-003': {
    id: 'test-event-003',
    name: '2026 全國英文閱讀素養競賽',
    description: `
      <p>本賽事旨在提升學生英文閱讀理解能力，培養國際競爭力。</p>
      <p>透過多元有趣的英文素材與題型設計，激發學生學習英文的動力。</p>
      <p>歡迎全國各校學生踴躍報名參加！</p>
    `,
    disclaimer: '*本活動報名時程詳見下方時程表',
    bannerImage: '',
    introUrl: '/goodkid',
    loginType: ['tmdId', 'eduId'],
    schedule: [
      { id: 'step1', name: '報名', startTime: 1770000000000, endTime: 1800000000000, location: '線上', description: '開放教師報名參加（目前進行中）' },
      { id: 'step2', name: '初賽', startTime: 1801000000000, endTime: 1810000000000, location: '各校教室', description: '進行初賽評比' },
      { id: 'step3', name: '決賽', startTime: 1811000000000, endTime: 1820000000000, location: '線上', description: '進行決賽評比' },
      { id: 'step4', name: '頒獎', startTime: 1821000000000, endTime: 1830000000000, location: '線上', description: '結果公布與頒獎' },
    ],
    groups: [
      { id: 'group-low', name: '國小低年級組' },
      { id: 'group-mid', name: '國小中年級組' },
      { id: 'group-high', name: '國小高年級組' },
      { id: 'group-junior', name: '國中組' },
      { id: 'group-senior', name: '高中組' },
    ],
    features: {
      showAwards: true,
      showExcellentSchools: true,
      showFormReminder: false,
      allowReviewer: true
    },
    awards: [
      {
        title: '國小高年級組',
        data: [
          { rank: '1', school: '臺北市大安國小', TName: '王美英', class: '六年一班' },
          { rank: '2', school: '新北市板橋國小', TName: '李思語', class: '六年二班' },
          { rank: '3', school: '桃園市中正國小', TName: '張英文', class: '五年三班' },
          { rank: 'excellent', school: '新竹市科學園區小學', TName: '陳語言', class: '六年四班' },
        ]
      },
      {
        title: '國中組',
        data: [
          { rank: '1', school: '臺北市建國中學', TName: '黃老師', class: '八年五班' },
          { rank: '2', school: '新北市江翠國中', TName: '古老師', class: '九年一班' },
          { rank: '3', school: '桃園市武陵高中', TName: '何老師', class: '七年二班' },
        ]
      }
    ],
    awardNotice: '恭喜以下參賽班級獲得佳績！',
    excellentSchoolsTitle: '英文閱讀素養優選學校',
    excellentSchools: [
      '臺北市立大安國小',
      '新北市立板橋國小',
      '桃園市立中正國小',
      '新竹市光武國中'
    ],
    formUrl: '',
    formTitle: '',
    formDeadline: '',
    sponsors: {
      supervisor: ['教育部國民及學前教育署'],
      organizer: ['臺灣英語教育推展協會'],
      coOrganizer: ['各縣市政府教育局處'],
      partner: ['國際英文教材出版社']
    },
    signUpGuide: `
      一、確認已安裝 HiTeach 軟體<br>
      二、建立學生名單（可使用簡易名單功能）<br>
      三、選擇參賽組別並提交<br>
      四、系統將發送確認通知到您的信箱
    `
  }
};

// ==================== 狀態變數 ====================
const isLoading = ref(true);
const eventData = ref({});
const defaultBanner = require('../../assets/img/bean/bean_05.png');
const defaultSignUpGuide = `
  一、HiTeach軟體安裝與基本操作<br>
  二、建立名單與官網班級報名<br>
  三、注意事項：請確認班級資料正確
`;

// 星星圖示陣列
const starIcons = [
  require('../../assets/img/symbol_starblue.png'),
  require('../../assets/img/symbol_stargreen.png'),
  require('../../assets/img/symbol_starred.png'),
  require('../../assets/img/symbol_staryellow.png'),
];

const getStarIcon = (index) => starIcons[index % starIcons.length];

// 使用者相關
const isPC = ref(true);
const isReviewer = ref(false);

// 頁面狀態
const ActiveStart = ref(false);
const PageStatus = ref(0); // 0:報名, 1:已報名, 2:活動開跑
const isJoin = ref(false);
const isPreSignUp = ref(false);
const classListCtrl = ref(false);

// 報名相關
const isMustSaveMainEmail = ref(false);
const isSaveMainEmail = ref(false);
const signUpEmail = ref('');
const userSchool = ref({});
const enrolledSchoolInfo = ref({});
const selectedSchool = ref('');
const optionsSchool = reactive([]);
const selectedRow = ref(null);

// 組別與課程
const groupListInfo = reactive([]);
const groupListOption = reactive([]);
const signUpGroupOptions = reactive([]);
const applyInfoData = reactive([]);
const applyTableData = ref([]);

// 對話框控制
const dialogSignUpCtrl = ref(false);
const dialogAfterLoginCtrl = ref(false);
const dialogAfterLoginNoPCCtrl = ref(false);
const dialogSetSchoolCtrl = ref(false);
const dialogAddClassCtrl = ref(false);
const dialogCreateClassCtrl = ref(false);

// 班級管理
const courseName = ref('');
const grouplistName = ref('');
const studentInput = ref('');
const students = ref([]);
const upsertMemberMode = ref('');

// 時程資料
const PlanData = reactive([]);
const Now_plan = ref('');

// 學校選擇器
const rawData = ref(country_v2);
const selectedLocation = ref([]);
const cascaderProps = { expandTrigger: "hover", value: "value", label: "label", children: "children" };

// ==================== Computed 屬性 ====================

// 判斷得獎名單是否可以顯示（活動結束後）
const isAwardRevealed = computed(() => {
  if (PlanData.length === 0) return false;
  
  const now = new Date().getTime();
  const lastStep = PlanData[PlanData.length - 1];
  const lastStepEndTime = parseInt(lastStep.stepEndTime);
  
  // 如果有設定專門的公布時間，使用該時間
  if (eventData.value.awardRevealTime) {
    return now > parseInt(eventData.value.awardRevealTime);
  }
  
  return now > lastStepEndTime;
});

// 報名是否已結束
const isSignUpClosed = computed(() => {
  const now = new Date().getTime();
  for (const step of PlanData) {
    // 使用 type === 'join' 判斷報名階段，相容性保留 stepName 比對
    if (step.type === 'join' || step.stepName === '報名' || step.stepName === '預報名') {
      const stepEndTime = parseInt(step.stepEndTime);
      if (now > stepEndTime) {
        return true;
      }
    }
  }
  return false;
});

// 是否已進入熱身賽階段
const isAfterWarmUpStage = computed(() => {
  const now = new Date().getTime();
  let warmUpStageIndex = -1;
  for (let i = 0; i < PlanData.length; i++) {
    if (PlanData[i].stepName.includes("熱身賽") || PlanData[i].stepName.includes("班級熱身賽")) {
      warmUpStageIndex = i;
      break;
    }
  }
  if (warmUpStageIndex === -1) return false;
  for (let i = warmUpStageIndex; i < PlanData.length; i++) {
    const stepStartTime = parseInt(PlanData[i].stepStartTime);
    if (now >= stepStartTime) {
      return true;
    }
  }
  return false;
});

// 選擇報名總數
const selectedCoursesCount = computed(() => {
  return signUpGroupOptions.reduce((groupTotal, group) => {
    return groupTotal + group.signUpClassData.reduce((classTotal, signUpClass) => {
      return classTotal + signUpClass.course.filter(course => course.selected).length;
    }, 0);
  }, 0);
});

// 總學生數
const totalStudents = computed(() => {
  return applyTableData.value
    .filter(item => item.groupId.some(id => id.trim() !== ""))
    .reduce((sum, item) => sum + item.students, 0);
});

// 總預估人數
const totalExpStuNum = computed(() => {
  return applyTableData.value
    .filter(item => item.groupId.some(id => id.trim() !== ""))
    .reduce((sum, item) => sum + item.expStuNum, 0);
});

// 學校 Cascader 選項
const cascaderOptions = computed(() => {
  const country = rawData.value.find((item) => item.t === "c");
  if (!country) return [];
  return [
    {
      label: country.cN,
      value: country.c,
      children: rawData.value
        .filter((item) => item.t === "y")
        .map((city) => ({
          label: city.yN,
          value: city.y            
        }))
    }
  ];
});

// 視窗寬度判斷
const isNarrow = ref(false);

// ==================== 核心函式 ====================

// 取得活動資料（優先使用本地 mock 資料，否則呼叫 API）
async function fetchEventData(eventId) {
  isLoading.value = true;

  // 優先使用本地 mock 資料（寫死的）
  const localData = mockEventData[eventId];
  if (localData) {
    eventData.value = localData;
    ActivityID.value = localData.id;
    processScheduleData(localData.schedule);
    processGroupData(localData.groups);
    isLoading.value = false;
    return true;
  }

  // 無本地資料，呼叫 API
  try {
    const res = await api.main.getEventData({ jointEventId: eventId });
    if (res && res.errCode === '' && res.jointEvent) {
      const data = JSON.parse(res.jointEvent);
      eventData.value = data;
      ActivityID.value = data.id;
      processScheduleData(data.schedule);
      processGroupData(data.groups);
      isLoading.value = false;
      return true;
    } else {
      ElMessage.error('找不到活動資料，請確認活動 ID 是否正確');
      isLoading.value = false;
      return false;
    }
  } catch (e) {
    ElMessage.error('載入活動資料失敗');
    isLoading.value = false;
    return false;
  }
}

// 處理時程資料
function processScheduleData(schedule) {
  PlanData.splice(0, PlanData.length);
  
  schedule.forEach((item, index) => {
    const pItem = {
      id: item.id,
      step: index + 1,
      stepStartTime: item.startTime,
      stepEndTime: item.endTime,
      startTime: formatTaiwanDate(item.startTime),
      endTime: formatTaiwanDate(item.endTime),
      stepName: item.name,
      location: item.location,
      description: item.description?.replace(/\n/g, "<br>") || '',
      blobsName: '',
      type: item.type || '',
      url: item.blobs?.[0]?.blob || '',
      urlOpen: false,
      isNow: false,
    };
    PlanData.push(pItem);
  });
  
  // 設定狀態
  const now = new Date().getTime();
  for (let step = 0; step < PlanData.length; step++) {
    const stepStartTime = parseInt(PlanData[step].stepStartTime);
    const stepEndTime = parseInt(PlanData[step].stepEndTime);
    const twoDaysLater = stepStartTime - 2 * 24 * 60 * 60 * 1000;
    
    PlanData[step].urlOpen = (now >= twoDaysLater);
    
    if (step >= 0 && now >= stepStartTime) ActiveStart.value = true;
    if (step >= 2 && now >= stepStartTime) PageStatus.value = 2;
    
    if (now >= stepStartTime && now <= stepEndTime) {
      PlanData[step].isNow = true;
      Now_plan.value = PlanData[step].id;
      if (PlanData[step].stepName === "預報名") {
        isPreSignUp.value = true;
      }
    }
  }
}

// 處理組別資料
function processGroupData(groups) {
  groupListInfo.splice(0, groupListInfo.length);
  groupListOption.splice(0, groupListOption.length);
  
  groups.forEach((item) => {
    groupListInfo.push({
      name: item.name,
      id: item.id
    });
  });
  
  // 設定組別選項
  groupListOption.push({ label: "請選擇組別...", value: [""] });
  groupListOption.push(...groupListInfo.map(item => ({ value: item.id, label: item.name })));
}

// 格式化日期為民國格式
function formatTaiwanDate(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear() - 1911;
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${year}/${month}/${day} ${hours}:${minutes}`;
}

// 時程表格樣式
const PlanDataRowClass = ({ row }) => {
  if (row.isNow) return 'tableBackground';
  return '';
};

// 取得組別名稱
function getGroupName(groupId) {
  const group = groupListInfo.find(item => item.id === groupId);
  return group ? group.name : '';
}



// ==================== 按鈕與對話框 ====================

function BtnFunction(val) {
  if (!isPC.value) {
    dialogAfterLoginNoPCCtrl.value = true;
    return;
  }
  
  if (val === 'join' && isSignUpClosed.value) {
    ElMessage({ message: '報名時間已結束，無法進行報名', type: 'warning', duration: 3000 });
    return;
  }
  
  dialogAfterLoginCtrl.value = false;
  
  // 模擬已登入狀態
  if (val === 'join') {
    ElMessage.info('此為展示頁面，報名功能需整合實際 API');
    dialogAddClassCtrl.value = true;
  } else if (val === 'edit') {
    dialogAddClassCtrl.value = true;
  }
}

function openSelectItem(rowItem) {
  dialogSignUpCtrl.value = true;
  selectedRow.value = JSON.parse(JSON.stringify(rowItem));
}

function openCreateClass(mode, scopeRow) {
  courseName.value = "HiTeach";
  grouplistName.value = "";
  studentInput.value = "";
  students.value = [];
  upsertMemberMode.value = mode;
  
  if (mode === 'upd' && scopeRow) {
    grouplistName.value = scopeRow.name;
    // 將既有學生載入 students 和 textarea
    if (scopeRow.memberList && scopeRow.memberList.length > 0) {
      students.value = JSON.parse(JSON.stringify(scopeRow.memberList));
      studentInput.value = scopeRow.memberList.map(s => `${s.name},${s.seat}`).join('\n');
    }
  }
  
  dialogCreateClassCtrl.value = true;
}

function addStudents() {
  students.value = [];
  const lines = studentInput.value.split('\n');
  const newStudents = [];
  
  for (const line of lines) {
    if (line && line !== "") {
      const [name, seat] = line.split(/[\t,]/);
      if (!/^\d+$/.test(seat)) {
        ElMessage.error("格式錯誤，請檢查名字及座號欄位是否正確");
        return;
      }
      if (newStudents.some(student => student.seat === seat)) {
        ElMessage.error(`姓名: ${name} 座號: ${seat} 已經存在！`);
        continue;
      }
      newStudents.push({ name, seat });
    }
  }
  students.value.push(...newStudents);
}

function deleteStudent(index) {
  students.value.splice(index, 1);
  ElMessage.success('學生已刪除');
}

function submitCourse() {
  if (upsertMemberMode.value === 'crt') {
    if (!grouplistName.value || students.value.length === 0) {
      ElMessage.error('請輸入課程名稱並添加學生！');
      return;
    }
  }
  ElMessage.success('展示模式：班級資料已模擬儲存');
  dialogCreateClassCtrl.value = false;
}

function dialogAddClassConfirm() {
  ElMessage.info('展示模式：報名資料已模擬送出');
  dialogSignUpCtrl.value = false;
}

function cancelConfirm() {
  ElMessageBox.confirm('確定要取消報名？', '取消報名', {
    confirmButtonText: '確定',
    cancelButtonText: '取消',
    type: 'warning',
  }).then(() => {
    ElMessage.success('報名已取消');
  }).catch(() => {});
}

function gotoTeammodel() {
  ElMessage.info('展示模式：跳轉至 IES5 系統');
}

function handleLocationChange(value) {
  if (value) {
    selectedSchool.value = "";
    // 模擬取得學校資料
    optionsSchool.length = 0;
    optionsSchool.push({ code: 'school-001', name: '測試國小', type: 1 });
    optionsSchool.push({ code: 'school-002', name: '範例國中', type: 2 });
  } else {
    optionsSchool.length = 0;
    selectedSchool.value = "";
  }
}

function setSchoolsubmit() {
  if (selectedSchool.value) {
    ElMessage.success('學校設定成功');
    dialogSetSchoolCtrl.value = false;
  } else {
    ElMessage.error('請選擇學校');
  }
}

// ==================== 生命週期 ====================

const handleResize = () => {
  isNarrow.value = window.innerWidth < 768;
  isPC.value = window.innerWidth >= 768;
};

onMounted(async () => {
  window.addEventListener('resize', handleResize);
  handleResize();
  
  // 寫死的 ID 優先；若為空則從 URL query 取得（並會呼叫 API）
  const eventId = HARDCODED_EVENT_ID || route.query.id;
  
  // 載入活動資料
  await fetchEventData(eventId);
  
  // 模擬一些報名資料
  applyTableData.value = [
    { courseName: 'HiTeach', name: '一年一班', groupId: ['group-low'], courseId: 'course-1', id: 'class-1', students: 3, type: 'simple', expStuNum: 30,
      memberList: [{name:'大雄', seat:'1'},{name:'胖虎', seat:'2'},{name:'小夫', seat:'3'}] },
    { courseName: 'HiTeach', name: '二年三班', groupId: [''], courseId: 'course-2', id: 'class-2', students: 2, type: 'simple', expStuNum: 0,
      memberList: [{name:'靜香', seat:'1'},{name:'小西', seat:'2'}] },
    { courseName: 'HiTeach', name: '三年二班', groupId: ['group-mid'], courseId: 'course-3', id: 'class-3', students: 2, type: 'simple', expStuNum: 32,
      memberList: [{name:'冒险少女', seat:'1'},{name:'武士', seat:'2'}] },
  ];
  
  // 模擬使用者資料
  userSchool.value = { schoolName: '測試國民小學', schoolId: 'test-school' };
  enrolledSchoolInfo.value = { schoolName: '測試國民小學' };
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

// 監聽路由變化
watch(() => route.query.id, async (newId) => {
  if (newId) {
    await fetchEventData(newId);
  }
});
</script>

<style lang="less" scoped>
@fontColor: #424f55;
@fontColor-light: #8da3a0;
@stressColor: #f59f56;
@fontColor-gray1: #909399;
@fontColor-gray2: #b1b3b8;
@other-blue: #70a6b2;
@background-gray: #eff4f7;

// Loading 覆蓋層
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  
  p {
    margin-top: 20px;
    font-size: 16px;
    color: @fontColor;
  }
}

// 表單容器
.form-container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px 30px;
}

.signup-form-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 2px 0;
  width: 100%;
}

.signup-info-group {
  background: #f5f9ff;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.signup-field-row {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.signup-field-label {
  font-size: 13px;
  color: #888;
  white-space: nowrap;
  min-width: 110px;
}

.signup-field-value {
  font-size: 15px;
  font-weight: 600;
  color: #2c3e50;
  word-break: break-all;
}

.form-item {
  margin-bottom: 28px;
  font-size: 16px;
}

.form-item strong {
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
}

.input-email {
  margin-bottom: 5px;
}

.input-width {
  width: 80%;
}

/deep/.el-cascader.input-width {
  width: 80%;
}

.spanTotal {
  border-right: solid;
  margin-right: 15px;
  border-color: lightgrey;
}

.spanTotal2 {
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  align-items: flex-end;
  display: flex;
}

.signup-dialog-footer {
  display: flex;
  justify-content: center;
  margin-top: 10px;
}

// /deep/ .el-dialog__header.show-close {
//   padding-right: 0px !important;
// }

/deep/ .el-dialog.login-dialog {
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
}

.login-dialog-header {
  padding: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  border-radius: 10px 10px 0 0;
  border-bottom: solid;
  border-color: gainsboro;
}

.login-dialog-content {
  margin-top: 20px;
  padding: 15px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  color: #444;
}

.title_school {
  font-weight: bold;
  font-size: 25px;
  margin-top: auto;
}

.a_color {
  color: @stressColor;
  cursor: pointer;
}

.otheBlueColor {
  color: @other-blue;
}

.stressColor {
  color: @stressColor;
}

.gray1Color {
  color: @fontColor-gray1;
}

.highlight-row {
  background-color: #fef0f0;
  color: #f56c6c;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 12px;
}

.current_progress {
  color: @stressColor;
  font-size: 12px;
  background: #fff3e0;
  padding: 2px 8px;
  border-radius: 4px;
}

// 活動資訊區域
.ActiveAllInfo {
  position: relative;
  margin-top: 10px;

  .ActiveTitle {
    font-size: 70px;
    margin-bottom: 10px;

    &.PC {
      font-size: 37px;
    }
  }

  .ActiveInfoDiv {
    margin-top: 10px;

    @media (max-width: 1250px) {
      display: flex;
      align-items: center;
      flex-direction: column;
    }

    .ActivePic {
      width: 250px;
      height: 250px;

      .pic {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .titleContentArea {
      margin-left: 20px;

      .otherInfoArea {
        flex: 1;
        min-width: 250px;
        max-width: 300px;
        margin-bottom: 20px;

        .Replenish {
          color: @fontColor-gray1;
          font-style: oblique;
        }

        @media (max-width: 1090px) {
          margin: 50px 20px;
        }
      }
    }
  }
}

// 按鈕區域
.joinButtonArea {
  margin-top: 30px;

  .joinButton {
    align-items: center;
    border-radius: 50px;
    font-size: 20px;
    font-weight: bold;
    width: 200px;
    height: 50px;
    background: @fontColor-gray1;
    cursor: no-drop;
    display: flex;
    justify-content: center;
    align-items: center;

    .txt {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    &.downLoad {
      background-color: @other-blue;

      &.load {
        cursor: pointer;
      }

      &.PC {
        margin-right: 20px;
      }
    }

    &.mar-right {
      &.PC {
        margin-right: 20px;
      }
    }

    &.onClick {
      background: @stressColor;
      cursor: pointer;
    }

    &.disabled {
      background: #ccc;
      color: #666;
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
}

// 內容區域
.cotentDiv {
  max-width: 1200px;
  width: 100%;
  padding: 20px;
}

.tableDiv {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  
  &.left {
    flex: 1;
  }
  
  &.right {
    width: 100%;
  }
}

.titleDiv {
  margin-bottom: 15px;
  
  .title {
    font-size: 18px;
    font-weight: bold;
    color: @fontColor;
    
    .iconPic {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
  }
}

// 得獎區域
.winCotent {
  margin-top: 20px;
  
  .ContestTitle {
    font-size: 16px;
    font-weight: bold;
    color: @fontColor;
    margin-bottom: 10px;
    padding: 8px 16px;
    background: #f5f7fa;
    border-radius: 4px;
  }
}

.tableCss, .tableCssPhone {
  margin-bottom: 15px;
}

.winTxt {
  margin-left: 8px;
  font-weight: 600;
}

// 學校列表
.schoolList {
  .list {
    padding: 8px 0;
    font-size: 16px;
    
    .iconPic {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}

// 表單提醒
.award-form-notice-pc,
.award-form-notice-mobile {
  background: #fff3e0;
  padding: 30px;
  border-radius: 12px;
  text-align: center;
  max-width: 800px;
  
  .form-link-decoration {
    font-size: 24px;
  }
}

// 時程區域
.scheduleArea {
  margin-bottom: 20px;
  
  .titleArea {
    margin-bottom: 10px;
    
    .stepName {
      font-size: 18px;
      font-weight: bold;
    }
  }
  
  .card {
    background: #f5f7fa;
    padding: 15px;
    border-radius: 8px;
    
    .place, .time {
      margin-bottom: 8px;
    }
    
    .description {
      color: @fontColor-gray1;
    }
  }
  
  .triangleArea {
    padding: 10px 0;
    
    .triangle {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 15px solid @other-blue;
    }
  }
}

// 頁尾
.footerDiv {
  background: @background-gray;
  padding: 30px;
  margin-top: 40px;
  
  .txtDiv {
    max-width: 1200px;
    line-height: 1.8;
    font-size: 14px;
    color: @fontColor-gray1;
  }
  
  &.phone {
    padding: 20px;
    
    .txtDiv {
      font-size: 12px;
    }
  }
}

// 對話框
.dialog-header {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  margin-left: -24px;
  margin-right: -24px;
  padding-left: 24px;
  padding-right: 24px;
  border-bottom: 2px solid #f0d9bc;
  
  .iconPic {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  
  .title {
    font-size: 18px;
    font-weight: bold;
  }
}

.applyTableDiv {
  .content {
    padding: 20px;
    
    .info {
      background: #fae6cb;
      padding: 15px;
      border-radius: 8px;
      margin-bottom: 20px;
      line-height: 1.8;
      border-left: 4px solid #f59f56;
    }
    
    .school-header {
      // background: #ebf5fb;
      margin-bottom: 15px;
      padding: 12px;
      border-radius: 8px;
      // border: 1px solid #a9cce3;
      
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #424f55;
      }
      
      .editButton {
        margin-left: 10px;
      }
    }
    
    .chooseArea2 {
      background: #f5f9ff;
      margin-bottom: 15px;
      padding: 12px;
      border-radius: 8px;
    }
  }
}

// 通用類別
.div-center {
  display: flex;
  justify-content: center;
}

.div-centerY {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.div-centerY2 {
  display: flex;
  align-items: center;
}

.oneLine {
  display: flex;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left {
  text-align: left;
}

.cursorPointer {
  cursor: pointer;
}

.whiteColor {
  color: white;
}

.picButton {
  position: relative;
  cursor: pointer;
  margin-top: 10px;
  width: 200px;
  height: 35px;

  &.big {
    width: 200px;
    height: 50px;
  }

  .buttonImg {
    height: 100%;
    width: 100%;
    display: block;
  }

  .pngText {
    font-size: 16px;

    &.big {
      font-size: 20px;
    }

    transform: translate(0%, -130%);
    color: white;
    font-weight: bold;
    text-align: end;
  }

  .txt {
    font-size: 20px;
    font-weight: bold;
  }
}

.signUpButton {
  background: @stressColor;
  border-color: @stressColor;
  color: white;
}

.urlCss {
  color: @other-blue;
  text-decoration: underline;
}

.line {
  height: 1px;
  background: #eee;
  margin: 10px 0;
}

// 表格背景
/deep/ .tableBackground {
  background-color: #fff8e1 !important;
}

// RWD
@media (max-width: 768px) {
  .cotentDiv {
    padding: 10px;
  }
}

</style>

<!-- 班級管理對話框主題：el-dialog teleport 至 body，須使用非 scoped 樣式 -->
<!-- ?style=sky   清新天空藍 -->
<!-- ?style=sage  自然鼠尾草綠 -->
<!-- ?style=warm  溫暖奶茶米白 -->
<!-- ?style=candy 糖果風 (保留) -->
<!-- ?style=ocean 海洋風 (保留) -->
<!-- ?style=game  遊戲風 (保留) -->
<style lang="less">

// ──────────────────────────────────────────────
// 純 HTML 卡片風格列表 (對話框內使用)
// ──────────────────────────────────────────────
.cardListContainer {
  width: 100%;
  overflow-y: auto;
  max-height: 400px;
  padding: 0;
}

.cardListHeader {
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1fr 1.8fr;
  gap: 16px;
  padding: 16px 20px;
  background: transparent;
  margin-bottom: 12px;
  font-weight: 700;
  font-size: 13px;
  color: #666;
  text-align: left;
  letter-spacing: 0.5px;
  border-bottom: 2px solid #eee;
}

.cardListBody {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cardRow {
  display: grid;
  grid-template-columns: 2fr 1fr 1.5fr 1fr 1.8fr;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e8e8e8;
  align-items: center;
}

.cardRow:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.cardColumn {
  display: flex;
  align-items: center;
  gap: 8px;
}

// 按鈕樣式 (純 HTML 按鈕替代 el-button)
.btn {
  padding: 4px 10px;
  font-size: 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
}

.btn-primary {
  background: #3a90d4;
  color: white;
}

.btn-primary:hover {
  background: #2970be;
}

.btn-secondary {
  background: #e6a23c;
  color: white;
}

.btn-secondary:hover {
  background: #cc8f1f;
}

.btn-warning {
  background: #f59f56;
  color: white;
}

.btn-warning:hover {
  background: #e07d3e;
}

.btn-danger {
  background: #f56c6c;
  color: white;
}

.btn-danger:hover {
  background: #f04c4c;
}

.btn-small {
  padding: 4px 8px;
  font-size: 11px;
}

// ──────────────────────────────────────────────
// 班級管理對話框預設樣式 (溫暖奶茶米白)
// ──────────────────────────────────────────────

.applyTableDiv {  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(66,79,85,0.14) !important;

  .el-dialog__header {
    background: transparent;
    padding: 16px 24px;
    .title {
      color: #424f55;
      font-size: 18px;
      font-weight: 700;
    }
    .el-dialog__headerbtn .el-icon { color: #f59f56 !important; }
  }

  .content .info {
    background: #d6eaf8;
    border-left: 4px solid #2e86c1;
    border-radius: 8px;
    color: #424f55;
    font-size: 14px;
  }

  .school-header .title { color: #424f55; font-size: 20px; font-weight: 700; }

  .chooseArea2 > div > span {
    background: #fdecd6 !important;
    color: #424f55 !important;
    padding: 3px 14px;
    border-radius: 6px;
    font-weight: 600;
    border: 1px solid #f5c98b;
  }

  .cardListHeader {
    background: #fae6cb !important;
    color: #424f55 !important;
  }

  .chooseArea2 .el-button--primary,
  .btn-primary {
    background: #f59f56 !important;
    border: none !important;
    border-radius: 6px;
    font-weight: 600;
  }

  .highlight-row {
    background: #f59f56 !important;
    color: #fff !important;
    border-radius: 5px;
  }
}

// 報名視窗：強制 body 撐滿寬（因 div-centerY 的 align-items:center 會收縮子元素）
.signup-dialog .el-dialog__body {
  width: 80%;
  box-sizing: border-box;
}

// ──────────────────────────────────────────────
// 新增/變更班級 步驟式佈局
// ──────────────────────────────────────────────
.createClass-step {
  width: 100%;
  margin-bottom: 18px;
}

.createClass-step-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #2e86c1;
  margin-bottom: 10px;
  border-bottom: 2px solid #d6eaf8;
  padding-bottom: 8px;
  width: 100%;
}

.step-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  background: #2e86c1;
  color: #fff;
  border-radius: 50%;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.createClass-name-row {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.createClass-course-tag {
  background: #2e86c1;
  color: #fff;
  padding: 4px 14px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.createClass-dash {
  color: #888;
  font-size: 18px;
}

.createClass-hint-body {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  flex-wrap: wrap;
}

.createClass-hint-text {
  flex: 1;
  font-size: 14px;
  line-height: 2;
  color: #424f55;
}

.createClass-hint-img {
  flex-shrink: 0;
  position: relative;
}

.hint-img-zoom {
  cursor: zoom-in;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  transform-origin: center center;
}

.hint-img-zoom:hover {
  transform: scale(2.8);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  z-index: 100;
  position: relative;
}

.createClass-editor {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 10px;
}

.createClass-editor-col {
  flex: 1;
}

.createClass-col-label {
  font-size: 13px;
  font-weight: 600;
  color: #2e86c1;
  margin-bottom: 6px;
}

.createClass-editor-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
}

.createClass-add-btn {
  white-space: nowrap;
  font-size: 13px;
  padding: 8px 14px;
}

</style>
